






















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import moduleStore from './store/audioCreating';
import PageState from './store/state';
import WorkTemplate from '@/views/migu/components/workTemplate.vue';
import CreateDrawer from '@/views/migu/components/createDrawer.vue';
import SimpleLoginPhone from '@/components/SimpleLoginPhone/SimpleLoginPhone.vue';
import SubscribePopup from '@/views/migu/components/subscribePopup.vue';
import AgreementDialog from '@/views/migu/components/agreementDialog.vue';
import { hasDecimal } from '@/utils/utils'
import { judgeDeviceType } from '@/utils/device';
import { visibility } from 'html2canvas/dist/types/css/property-descriptors/visibility';
import { MiguConfig } from '@/views/migu/utils/constant';
import { toast } from '@/utils/util'
import to from 'await-to-js';

const notLoginMessage = '请先登录';
const notLoginErrorMessage = 'token错误请重新登录';
	@Component({
    components:{
      WorkTemplate,
      CreateDrawer,
      SimpleLoginPhone,
      SubscribePopup,
      AgreementDialog
    }
  })
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
export default class AudioCreating extends Vue implements IvuePage<PageState>{
  state = new PageState();
	self:Vue = this;
  progress = '0%';
  queueNum = 0;//排队人数
  articleId =null;//当前文章id
  articleStatus = 0;//当前文章状态
  statusTimer = null;//获取文章状态定时器
  statusTxt='视频排队中,请耐心等待....'
  progressNum = 0;
  isApp = judgeDeviceType.isAPP;
  isMiguApp = judgeDeviceType.isMigu; // 咪咕app

  isNewYear = false;
  theme = '';
  taskId = '';
  showCreateDrawer = false;
  isSubmiting = false;
  showLoginPopup = false;
  showSubscribePopup = false;
  // ============ 协议弹窗（抽屉勾选框点协议名触发） ============
  showAgreementPopup = false;
  drawerOpenBeforeAgreement = false; // 弹协议前抽屉是否打开（关闭协议后恢复）
  drawerAgreed = false; // 协议勾选状态（弹窗点「我已阅读并同意」后置 true，同步进抽屉）

  // 创作抽屉回显数据（从发音人搜索页返回后恢复）
  drawerText = '';
  drawerStyleCode = '';
  drawerSpeakerName = '';
  drawerSpeakerStyleId: any = 0;
  drawerSpeakerStyleName = '';
  drawerSpeechSpeed = '';

  created(){
    this.theme = localStorage.getItem('theme') || '';
    this.isNewYear = this.theme === 'New_Year';
    // this.taskId = localStorage.getItem('creationTaskIdMigu') || '';
  }
  mounted(){
    this.articleId = this.$route.query.articleId;
    if(this.articleId){
      this.initProgress();
      //获取文章状态
      this.getArticleStateFn();
    }
    if (this.isMiguApp) {
      this.statusTxt = '正在生成视频,请耐心等待....'
    }
    // 从咪咕 taskId 页返回：消费 taskId 并直接触发提交
    this.setTaskId();
    // 从发音人搜索页返回：恢复抽屉打开状态和草稿
    this.restoreCreateDrawer();
  }

  // 同路由自跳（本页抽屉提交成功后 push /audioCreating?articleId=新id）组件复用不触发 mounted，
  // watch articleId 变化，为新作品重启轮询
  @Watch('$route.query.articleId')
  onArticleIdChange(newId: any, oldId: any) {
    if (newId && newId !== oldId) {
      this.clearStatusTimer();
      this.articleId = newId;
      this.progressNum = 0;
      this.progress = '0%';
      this.maxProgress = 0;
      this.temporarilyProgress = 0;
      this.statusTxt = this.isMiguApp ? '正在生成视频,请耐心等待....' : '视频排队中,请耐心等待....';
      this.getArticleStateFn();
    }
  }

  // 恢复创作抽屉（发音人搜索页选完发音人返回时）
  restoreCreateDrawer() {
    const reopen = localStorage.getItem('createDrawerReopen');
    if (reopen !== 'true') return;
    localStorage.removeItem('createDrawerReopen');
    const data = JSON.parse(localStorage.getItem('createDrawerMiguData') || 'null');
    if (data) {
      this.drawerText = data.text || '';
      this.drawerStyleCode = data.styleCode || '';
      this.drawerSpeakerName = data.speakerName || '';
      this.drawerSpeakerStyleId = data.speakerStyleId || 0;
      this.drawerSpeakerStyleName = data.speakerStyle || '';
      this.drawerSpeechSpeed = data.speechSpeed || '';
    }
    this.showCreateDrawer = true;
  }
  // 最大前端假进度
  maxProgress = 0
  // 前端假进度
  temporarilyProgress = 0
  getArticleStateFn(){
    const httpFun = this.isMiguApp ? 'getMiguArticleStatus' : 'getArticleStatus';
    this.$http(httpFun,{articleId:this.articleId}).then(res=>{
      console.log('文章状态',res);
      if(res.code == 200){
        this.articleStatus = res.data.status
        if(this.articleStatus == 1){//排队中 
          this.queueNum = res.data.rank;
          if (this.isMiguApp) {
            this.statusTxt = '正在生成视频,请耐心等待....'
          } else {
            this.statusTxt = '视频排队中,请耐心等待....'
          }
        }else if(this.articleStatus == 4){//生图中
          this.statusTxt = '正在生成视频,请耐心等待....'
          // ===== 旧方案：前端假进度（已注释保留） =====
          // const imageCount = res.data.imageCount;
          // const progress = res.data.progress
          // if (imageCount === 0) {
          //   this.updateProgress()
          // } else if (imageCount > 0 && !progress) {
          //   if (this.maxProgress === 0) {
          //     this.maxProgress = 1 / imageCount * 100 - 1
          //   }
          //  if (this.temporarilyProgress / 10 < this.maxProgress) {
          //   this.updateProgress()
          //  }
          // } else {
          //   this.progress = progress || '0%'
          //   let progressNum = 0;
          //   if(typeof res.data.progress === 'string') {
          //     const _progerss = parseInt(res.data.progress.match(/\d+/g)) || 0;
          //     if (_progerss >= this.temporarilyProgress) {
          //       progressNum = _progerss
          //     } else {
          //       progressNum = this.temporarilyProgress
          //     }
          //   }
          //   if (progressNum) {
          //     this.progressNum = progressNum;
          //   }
          // }
          // ===== 新方案：生图中固定显示 0%，进度不增长 =====
          this.progressNum = 0;
          this.progress = '0%';
          
        }
        let end = this.articleStatus == 5 || this.articleStatus == 6
        if(this.articleStatus == 6 && this.isMiguApp){ //成功
          this.statusTxt = '正在导出视频,请耐心等待....';
          this.progressNum =  parseInt((res.data.exportProgress || '').match(/\d+/g)) || 0;
          const exportStatus = res.data.lastExportTaskStatus || 0;
          end = exportStatus > 1;
        }
        if(end){
          this.clearStatusTimer()
          if (this.isMiguApp && res.data.articleId) { 
          // 将接口返回的articleId存入本地
            localStorage.setItem('articleIdMigu', res.data.articleId);
          }
          if(this.articleStatus == 5){//失败
            this.statusTxt = '生成失败';
            this.progress = res.data.progress||'图片生成失败';
            this.$toast({
              message: res.data.progress||'图片生成失败',
              duration: 3000
            });
            this.toWroks();
          }else{//成功
            this.statusTxt = '生成成功';
            this.progressNum = 100;
            this.progress = '生图进度100%';
            this.toEditPage();
          }
        }
        if(!end){//未结束
          this.statusTimer = setInterval(()=>{
            this.clearStatusTimer()
            // this.type = 'timer'
            this.getArticleStateFn()
          }, 3 * 1000)
        }
      }
    })
  }

  toEditPage() {
    if (this.isMiguApp){
      this.toWroks();
      return;
    }
    let videoUrl = window.location.origin + '/#/videoEditor?from=loading&articleId=' + this.articleId
    const ww_token = localStorage.getItem('ww_token')
    if (ww_token) {
      videoUrl = videoUrl + '&ww_token=' + ww_token
    }
    if(this.isApp){
      let switchWebviewUrl = (<any>window).switchWebviewUrl;
      switchWebviewUrl.postMessage(videoUrl)
    }else{
      this.$redirectTo({
        url: '/pages/webview/webview?url=' + encodeURIComponent(videoUrl),
      })
    }
    // this.$router.push({path:'/videoEditor',query:{articleId:this.articleId}})
  }

  initProgress() {
    // ===== 旧方案：恢复前端假进度（新方案生图中固定显示0%，不再恢复） =====
    // let progressInfo: any = localStorage.getItem('progressInfo')
    // if (progressInfo) {
    //   progressInfo = JSON.parse(progressInfo)
    //   if (progressInfo.articleId ==  this.articleId) {
    //     this.temporarilyProgress = progressInfo.temporarilyProgress
    //     this.progressNum = progressInfo.progressNum
    //   }
    // }
  }
  // ===== 旧方案：前端假进度递增（新方案已停用，保留方法体） =====
  // updateProgress() {
  //   this.temporarilyProgress = this.temporarilyProgress + 1
  //   this.progressNum = this.temporarilyProgress / 10
  //   if (hasDecimal(this.progressNum)) {
  //     this.progressNum = this.progressNum = Number(this.progressNum.toFixed(1))
  //   }
  //   localStorage.setItem('progressInfo', JSON.stringify({
  //     articleId: this.articleId,
  //     temporarilyProgress: this.temporarilyProgress,
  //     progressNum: this.progressNum
  //   }))
  // }
  updateProgress() {}
  clearStatusTimer(){
    this.statusTimer && clearInterval(this.statusTimer)
    this.statusTimer = null
  }
  toWroks(){
    console.log('---隐藏界面,跳转到其他页面');//todo-待与其他页面交互
    if(this.isMiguApp){
      this.$router.replace({ path:'/migu-works' });
    }else if (this.isApp) {
      let switchToWork = (<any>window).switchToWork;
      switchToWork.postMessage('')
    } else {
      this.$switchTab({
        url:'/pages/works/works'
      })
    }
  }
  // 右上角「我的作品」入口：与 textToVideo 的 toWorksPage 行为一致
  toWorksPage() {
    this.$router.push({ path: '/migu-works' });
  }
  toTemplate() {
    this.$router.replace({ path:'/migu', query: { anchor: 'template'} });
  }
  doReload() {
    this.$router.replace({ path: '/migu' });
  }

  // ============ 创作抽屉提交逻辑 ============

  // 检查登录
  checkLogin() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.showLoginPopup = true;
        return false;
      }
    }
    return true;
  }

  // 提交前验证（对齐 textToVideo.beforeSumitVerify：基础校验 + 上一个任务状态检查）
  async beforeSubmitVerify(params: any) {
    if (!params.originContent) {
      toast('请输入文案');
      return false;
    }
    if (params.originContent.length < 35) {
      toast('请输入至少35个字');
      return false;
    }
    if (!params.speaker) {
      toast('请选择发音人');
      return false;
    }
    // 上一个任务未完成（非失败/成功导出终态）时，不允许重复提交
    // 注意：本页 store 的 getArticleStatus 是非 migu URL，migu 版为 getMiguArticleStatus（与 textToVideo 一致）
    const lastArticleId = localStorage.getItem('miguLastArticleId');
    if (lastArticleId) {
      const [error, res] = await to(this.$http('getMiguArticleStatus', { articleId: lastArticleId }));
      if (!error && res.code === 200 && res.data) {
        const status = res.data.status; // 5失败, 6成功
        const lastExportTaskStatus = res.data.lastExportTaskStatus; // 2成功,3/4失败
        if (status === 5 || (status === 6 && [2, 3, 4].includes(lastExportTaskStatus))) {
          localStorage.removeItem('miguLastArticleId');
        } else {
          toast('已有处理中的任务, 请稍后再次提交');
          return false;
        }
      }
    }
    return true;
  }

  // 抽屉提交（对齐 textToVideo.doSubmit：async 验证 + await getMiguToken）
  async onDrawerSubmit(params: any) {
    if (this.isSubmiting) return;
    if (!this.checkLogin()) return;
    const verify = await this.beforeSubmitVerify(params);
    if (!verify) return;
    this.isSubmiting = true;

    // 补全提交参数
    params.creationTaskId = this.taskId;
    params.title = params.originContent.slice(0, 80);
    params.platform = 'MIGU';
    params.resourceType = 'ONE_CLICK';
    params.articleTransform = 0;

    try {
      if ((window as any).getMiguToken) {
        const rcToken = await (window as any).getMiguToken();
        params.rcToken = rcToken;
      }
    } catch (e) {
      console.error('getMiguToken error', e);
    }

    this.doSubmitRequest(params);
  }

  doSubmitRequest(params: any) {
    params.channelCode = MiguConfig.schannel;
    this.$http('submitCreate', params).then((res: any) => {
      this.isSubmiting = false;
      if (res.code == 200) {
        this.isSubmiting = true;
        try {
          if ((window as any)._amberTrack) {
            localStorage.setItem('creationTaskIdMigu', params.creationTaskId + '');
            const vuid = localStorage.getItem('vuid') || '';
            (window as any)._amberTrack('music_aigc_submit_task', [
              { EK: 'triggerType', EV: '2' },
              { EK: 'scene', EV: MiguConfig.projectId },
              { EK: 'taskId', EV: params.creationTaskId },
              { EK: 'vuid', EV: vuid },
              { EK: 'appId', EV: MiguConfig.appid },
              { EK: 'channel', EV: MiguConfig.schannel }
            ], true, 'beacon');
          }
        } catch (e) {}
        localStorage.setItem('miguLastArticleId', res.data.articleId + '');
        this.showCreateDrawer = false;
        this.$router.push({ path: '/audioCreating', query: { articleId: res.data.articleId, source: 'app_migu' } });
      } else if (res.message == notLoginMessage) {
        this.doLogin();
      } else {
        toast(res.message);
      }
    }).catch((err: any) => {
      this.isSubmiting = false;
      if (err?.response?.data?.message === notLoginErrorMessage) {
        this.doLogin();
      }
    });
  }

  // 查询 taskId（跳转咪咕 taskId 页获取，回来后由 setTaskId 触发提交）
  // 对齐 works.ts 的 onDrawerQueryTask：跳转前存提交标记和参数
  async onDrawerQueryTask() {
    if (this.taskId) {
      // 已有 taskId，直接提交
      const drawerRef = this.$refs.createDrawerRef as any;
      if (drawerRef) {
        drawerRef.doCreateSubmit();
      }
      return;
    }
    if (!this.checkLogin()) return;

    // 跳转前校验参数，避免空参数白跳一趟
    const drawerRef = this.$refs.createDrawerRef as any;
    const submitParams = drawerRef ? drawerRef.submitParams : {};
    const verify = await this.beforeSubmitVerify(submitParams);
    if (!verify) return;

    this.setLocalStorageData(); // 草稿回显（回来后恢复抽屉用）
    // 存提交标记 + 提交参数，跳转回来后 setTaskId 直接触发提交
    localStorage.setItem('isMiguSubmit', 'true');
    localStorage.setItem('audioCreatingMiguSubmitData', JSON.stringify(submitParams));
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');

    // 获取 btoken
    const btoken = localStorage.getItem('btoken') || '';

    // 根据 commonPub 标识决定使用哪个 URL（taskId 专用页，与 works/textToVideo 一致）
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      let url = `https://y.migu.cn/app/v5/p/middle/ai-channel-task-id/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}`;
      if (btoken) {
        url += `&btoken=${btoken}`;
      }
      url += '&pm=hash#/task-id';
      window.location.href = url;
    } else {
      window.location.href = `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash#/task-id`;
    }
  }

  // 设置taskId（从咪咕 taskId 页返回后触发提交，对齐 works.ts 的 setTaskId）
  setTaskId() {
    const isMiguSubmit = localStorage.getItem('isMiguSubmit');
    if (!isMiguSubmit) return; // 不是提交过来的，不去取taskId
    const query = this.$route.query;
    const taskId = query.taskId || '';
    if (typeof taskId === 'string') this.taskId = taskId; // 空值不覆盖已有值
    if (!taskId) {
      const resumeCode = query.resumeCode || '';
      // 用户支付状态码0：用户支付失败, 1：用户支付成功, 2：用户取消支付, 3：用户已有次数, 4：获取taskId获取失败
      const error = query.info as string;
      if (resumeCode === '4') {
        let msg = error || '获取taskId失败';
        if (msg.includes('存在进行中的任务')) msg = '存在进行中的任务';
        toast(msg, 'middle', 5000);
      } else if (resumeCode === '2') {
        toast(error || '您已取消支付');
      } else if (resumeCode === '0') {
        toast(error || '支付失败');
      }
      // 失败/取消：清标记并恢复抽屉，用户可修改后重试
      localStorage.removeItem('isMiguSubmit');
      localStorage.setItem('createDrawerReopen', 'true');
      this.restoreCreateDrawer();
      return;
    }
    // 有taskId：读取跳转前存的提交参数，直接触发提交
    const data = JSON.parse(localStorage.getItem('audioCreatingMiguSubmitData') || 'null');
    localStorage.removeItem('isMiguSubmit');
    if (!data) return;
    data.creationTaskId = taskId;
    this.onDrawerSubmit(data);
  }

  // 登录
  doLogin() {
    this.showCreateDrawer = false;
    this.setLocalStorageData();
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    const btoken = localStorage.getItem('btoken') || '';
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      window.location.href = `https://y.migu.cn/app/v5/p/middle/ai-channel-token/index.html?appId=${MiguConfig.appid}&schannel=${MiguConfig.schannel}&projectId=${MiguConfig.projectId}&releaseId=75348636&cburl=${encodeURIComponent('https://h5.yuan365.com/#/migu')}&pm=hash&cToken=${btoken}`;
    }
  }

  // 保存草稿到 localStorage
  setLocalStorageData() {
    const drawerRef = this.$refs.createDrawerRef as any;
    if (drawerRef) {
      const params = drawerRef.saveParams;
      // 存到抽屉专用 key，与发音人搜索页 speakerInfo 的读写保持一致
      localStorage.setItem('createDrawerMiguData', JSON.stringify(params));
      // 同步到页面 state，抽屉销毁重建（v-if）后重开可回显
      this.drawerText = params.text || '';
      this.drawerStyleCode = params.styleCode || '';
      this.drawerSpeakerName = params.speakerName || '';
      this.drawerSpeakerStyleId = params.speakerStyleId || 0;
      this.drawerSpeakerStyleName = params.speakerStyle || '';
      this.drawerSpeechSpeed = params.speechSpeed || '';
    }
  }

  // 跳转付费
  doPay() {
    this.setLocalStorageData();
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    window.location.href = `https://y.migu.cn/app/v5/p/ai-pay/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash`;
  }

  // 显示订购弹窗
  showSubscribe() {
    this.showSubscribePopup = true;
  }

  // 登录成功（simple-login-phone 回调）：跳咪咕 token 换取页
  onLoginSuccess(res) {
    this.showLoginPopup = false;
    const { migu_token } = res;
    localStorage.setItem('miguDidLogin', '1');
    localStorage.setItem('migu_token', migu_token);
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    window.location.href = `https://y.migu.cn/app/v5/p/middle/ai-channel-token/index.html?appId=${MiguConfig.appid}&schannel=${MiguConfig.schannel}&projectId=${MiguConfig.projectId}&cburl=${cburl}&pm=hash&cToken=${migu_token}`;
  }

  closeLogin() {
    this.showLoginPopup = false;
  }

  closeSubscribe() {
    this.showSubscribePopup = false;
  }

  // ============ 协议弹窗（抽屉勾选框点协议名触发） ============

  // 勾选框点协议名：关闭抽屉（若打开），弹协议弹窗
  onShowAgreement() {
    this.drawerOpenBeforeAgreement = this.showCreateDrawer;
    if (this.showCreateDrawer) {
      this.showCreateDrawer = false;
    }
    this.showAgreementPopup = true;
  }

  // 协议弹窗点「我已阅读并同意」：自动勾选抽屉协议
  onAgreementAgree() {
    this.drawerAgreed = true;
  }

  // 关闭协议弹窗：恢复协议弹出前的抽屉打开状态
  onAgreementClose() {
    this.showAgreementPopup = false;
    if (this.drawerOpenBeforeAgreement) {
      this.showCreateDrawer = true;
      this.drawerOpenBeforeAgreement = false;
    }
  }
  beforeDestroy() {
    this.clearStatusTimer()
  }
}
